import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-news-image-avatar',
  imports: [],
  templateUrl: './news-image-avatar.component.html'
})
export class NewsImageAvatarComponent {
  imageUrl = input.required<string | undefined>();
  size = input<string>();

  sizeStyle = computed<string>(() => this.size() ? `avatar-${this.size()}` : '');
}
